import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls window to the top whenever the route (pathname) changes.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Jump instantly to the very top on every navigation
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
